var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 12.2506V9.33337H4L4.51587 12.4286C4.60289 12.9507 5.05461 13.3334 5.5839 13.3334C6.1819 13.3334 6.66667 12.8486 6.66667 12.2506Z",
    fill: "#0A51C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.33306C2 6.22849 2.89543 5.33306 4 5.33306H6L7.33333 5.33332L11.4917 2.90043C12.6028 2.25038 14 3.05171 14 4.33898V10.3315C14 11.6193 12.6017 12.4205 11.4906 11.7694L7.33333 9.33306H6H4C2.89543 9.33306 2 8.43763 2 7.33306Z",
    fill: "#0A51C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.18519C12 6.53063 12.5306 6 13.1852 6H13.3333C14.0697 6 14.6667 6.59695 14.6667 7.33333C14.6667 8.06971 14.0697 8.66667 13.3333 8.66667H13.1852C12.5306 8.66667 12 8.13604 12 7.48148V7.18519Z",
    fill: "#0A51C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33337 5.33332L11.4917 2.90043C12.6028 2.25038 14 3.05171 14 4.33898V10.3315C14 11.6193 12.6018 12.4205 11.4907 11.7694L7.33337 9.33306V5.33332Z",
    fill: "#0A51C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.5505c09bebb659b10d7eb9c1a520757d.svg";
export { ForwardRef as ReactComponent };